import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import Loader from '../../components/Loader';
import { config } from '../../env';
const ENV_NAME = config.env_name;

// ==============================|| AUTH GUARD ||============================== //

const FreeUserGuard = ({ children }: GuardProps) => {
  const { isAuthenticated, isSignUpFinished, user } = useAuth();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>(undefined);
  const [isPaid, setIsPaid] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const localMaintenance = localStorage.getItem('CURRENT_MAINTENANCE_' + ENV_NAME);
    if (localMaintenance && localMaintenance.toUpperCase() === 'TRUE') {
      console.log('Redirecting to maintenance');
      navigate('maintenance', { replace: true });
    }
    console.log('----------------------- ', isSignUpFinished && isAuthenticated);
    setIsAdmin(user?.roles?.includes('Admin'));
    setIsPaid(user?.roles?.includes('Paid Member'));
    if (!isAuthenticated) {
      navigate('login', { replace: true });
    } else if (isSignUpFinished !== undefined && isAuthenticated && !isSignUpFinished) {
      navigate('welcome', { replace: false });
    } else if (isSignUpFinished && isAuthenticated && window.location.pathname.slice(0, 8) === '/welcome') {
      navigate('pricing', { replace: true });
    } else if (
      isSignUpFinished &&
      isAuthenticated &&
      (isAdmin === true || isPaid === true) &&
      window.location.pathname.includes('pricing')
    ) {
      console.log('!isAdmin && !isPaid : ', !isAdmin && !isPaid);
      console.log('user roles : ', isAdmin, isPaid, isSignUpFinished, window.location.pathname.slice(0, 8));
      navigate('dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate, isSignUpFinished, user]);

  if (isSignUpFinished !== undefined) {
    return children;
  } else {
    return <Loader />;
  }
};

export default FreeUserGuard;
